import { $apiDelete, $apiGet, $apiPost, $apiPut } from '~/utils/request'
import type { LawEventType } from '~/models'

export const GetAll = () => $apiGet<LawEventType[]>(`/v1/lawEventType/all`)

export const GetByLawFirmCaseEncryptionId = params => $apiGet<LawEventType[]>(`/v1/lawEventType/byLawFirmCaseEncryptionId`, params)
